<template>
  <div
    class="layout-sidenav sidenav sidenav-vertical bg-sidenav-theme vh-100"
    :class="{'nav-collapsed': collapseNav}"
  >
    <router-link
      :to="{name: 'organisation-dashboard'}"
      class="app-brand-text p-3 demo sidenav-text font-weight-normal w-100 text-center">
      <img
        :src="org.logo || require('@/common/assets/img/logo-white.png')"
        class="img-fluid w-100"
        :alt="org.name"
      />
    </router-link>

    <div class="sidenav-divider mt-0"></div>
    <ul class="sidenav-inner py-1 ps overflow-auto">
      <li class="sidenav-item">
        <router-link
          :to="{name: 'organisation-dashboard'}"
          class="sidenav-link"
          id="left-nav-organisation-dashboard"
        >
          <i class="fa fa-nav fa-home"></i>
          <span v-if="!collapseNav">{{ $t('word.organisation_dashboard') }}</span>
        </router-link>
      </li>
      <li
        class="sidenav-item"
      >
        <router-link
          :to="{name: 'organisation-register-research-start'}"
          class="sidenav-link"
          id="left-nav-organisation-register-research-start"
        >
          <i class="fa fa-nav fa-plus"></i>
          <span v-if="!collapseNav">{{ $t('phrase.register_commercial') }}</span>
        </router-link>
      </li>
      <li
        class="sidenav-item"
      >
        <router-link
          :to="{name: 'organisation-research-list'}"
          class="sidenav-link"
          id="left-nav-organisation-research-list"
        >
          <i class="fa fa-nav fa-chart-line"></i>
          <span v-if="!collapseNav">{{ $tc('word.research', 2) }}</span>
        </router-link>
      </li>

      <li class="sidenav-item" v-if="user.memberships.length > 1">
        <router-link
          :to="{name: 'organisation-list'}"
          class="sidenav-link"
          id="left-nav-organisation-list"
        >
          <i class="fa fa-list fa-nav"></i>
          <span v-if="!collapseNav">{{ $t('phrase.my_organisations') }}</span>
        </router-link>
      </li>

      <li class="sidenav-item">
        <router-link
          :to="{name: 'organisation-organisation-detail'}"
          class="sidenav-link"
          id="left-nav-organisation-detail"
        >
          <i class="fa fa-building fa-nav"></i>
          <span v-if="!collapseNav">{{ $t('phrase.my_organisation') }}</span>
        </router-link>
      </li>

      <li class="sidenav-item">
        <router-link
          :to="{name: 'organisation-user-profile'}"
          class="sidenav-link"
          id="left-nav-user-profile"
        >
          <i class="fa fa-user fa-nav"></i>
          <span v-if="!collapseNav">{{ $t('phrase.my_account') }}</span>
        </router-link>
      </li>

      <li class="sidenav-item">
        <a
          :href="getBackendUrl('/auth/logout/')"
          class="sidenav-link text-danger"
          id="left-nav-logout"
        >
          <i class="fa fa-power-off text-danger fa-nav"></i>
          <span v-if="!collapseNav">{{ $t('word.logout') }}</span>
        </a>
      </li>

      <hr/>
      <li class="sidenav-item">
        <a href="/dashboard/" class="sidenav-link text-primary">
          <i class="fa fa-table-columns fa-nav"></i>
          <span v-if="!collapseNav">{{ $t('word.reviewers_dashboard') }}</span>
        </a>
      </li>

      <li class="sidenav-item">
        <router-link
          class="sidenav-link"
          :to="{ name: 'admin-dashboard' }"
          v-if="user.su"
        >
          <i class="fa fa-database text-light fa-nav"></i>
          <span v-if="!collapseNav">{{ $t('word.admin') }}</span>
        </router-link>
      </li>

      <li
        v-if="!collapseNav"
        class="sidenav-item open" :class="{open: showExtra}"
      >
        <a
          @click="showExtra = !showExtra"
          href="javascript:void(0)"
          class="sidenav-link"
        >
          <i
            class="fa fa-chevron-down fa-nav"
            :class="{'fa-chevron-down': showExtra, 'fa-chevron-right': !showExtra}"
          />
          <div>{{ $t('word.extra') }}</div>
        </a>
        <v-collapse-transition>
          <ul class="sidenav-menu" v-if="showExtra">
            <li class="sidenav-item">
              <a
                href="https://commercialreview.nl/bedrijven/"
                target="_blank"
                class="sidenav-link"
              >
                <i class="fa fa-newspaper mr-2"></i>
                {{ $t('phrase.for_companies') }}
              </a>
            </li>

            <li class="sidenav-item">
              <a
                href="https://commercialreview.nl/over-ons/"
                target="_blank"
                class="sidenav-link"
              >
                <i class="fa fa-newspaper mr-2"></i>
                {{ $t('phrase.about_us') }}
              </a>
            </li>
            <li class="sidenav-item">
              <a
                href="https://commercialreview.nl/privacystatement/"
                target="_blank"
                class="sidenav-link"
              >
                <i class="fa fa-newspaper mr-2"></i>
                {{ $t('word.privacy_statement') }}
              </a>
            </li>
            <li class="sidenav-item">
              <a
                href="https://commercialreview.nl/voorwaarden/"
                target="_blank"
                class="sidenav-link"
              >
                <i class="fa fa-newspaper mr-2"></i>
                {{ $t('word.terms') }}
              </a>
            </li>
            <li class="sidenav-item">
              <a
                href="https://commercialreview.nl/contact/"
                target="_blank"
                class="sidenav-link"
              >
                <i class="fa fa-newspaper mr-2"></i>
                {{ $t('word.contact') }}
              </a>
            </li>
          </ul>
        </v-collapse-transition>
      </li>
    </ul>
    <div class="d-flex justify-content-end w-100">
      <v-button
        style-type="link text-white"
        :icon="collapseNav ? 'arrow-right' : 'arrow-left'"
        @click="toggleCollapseNav"
      />
    </div>
  </div>
</template>

<script>
import Button from '@/common/components/Button.vue';
import { mapGetters } from 'vuex';
import { CollapseTransition } from '@ivanv/vue-collapse-transition';
import { getBackendUrl } from '@/common/utils/api';

export default {
  name: 'OrganisationNavBar',
  methods: {
    getBackendUrl,
    toggleCollapseNav() {
      this.collapseNav = !this.collapseNav;
      localStorage.setItem('collapseNav', this.collapseNav);
    },
  },
  components: {
    'v-collapse-transition': CollapseTransition,
    'v-button': Button,
  },
  computed: {
    ...mapGetters(['user', 'org']),
  },
  data() {
    return {
      showExtra: false,
      collapseNav: localStorage.getItem('collapseNav') === 'true',
      showOrganisations: false,
      commercialRoutes: ['org-commercials', 'org-commercial-dashboard'],
    };
  },
};
</script>


<style scoped>
.fa-nav {
  width: 27px;
}

.nav-collapsed {
  width: 60px;
}

.nav-collapsed li.sidenav-item {
  width: 60px;
  padding: 0;
  margin: 0;

}

.nav-collapsed a.sidenav-link {
  width: 60px;
  padding: .75rem 0;
  display: flex;
  justify-content: center;
  text-align: center;
}
</style>
